/* import __COLOCATED_TEMPLATE__ from './period-chooser-row.hbs.js'; */
import { classNames } from "@ember-decorators/component";
import discourseComputed from "discourse/lib/decorators";
import { i18n } from "discourse-i18n";
import DropdownSelectBoxRowComponent from "select-kit/components/dropdown-select-box/dropdown-select-box-row";
const PeriodChooserRow = dt7948.c(class PeriodChooserRow extends DropdownSelectBoxRowComponent {
  title(rowName) {
    return i18n(`filters.top.${rowName || "this_week"}`).title;
  }
  static {
    dt7948.n(this.prototype, "title", [discourseComputed("rowName")]);
  }
}, [classNames("period-chooser-row")]);
export default PeriodChooserRow;